import React, { Component } from "react";
import { Query } from "react-apollo";

import SubscribeStreamCap from "stream/components/SubscribeStreamCap";
import EventStreamCap from "stream/components/EventStreamCap";
import ErrorBoundary from "components/Library/ErrorBoundary";
import STREAM_CAP_QUERY from "./StreamCap.graphql";

import styles from "./StreamCap.css";

class StreamCap extends Component {
  render() {
    return (
      <ErrorBoundary>
        <Query query={STREAM_CAP_QUERY}>
          {({ loading, data }) => {
            const { newsletterSignup, event } = data;

            if (loading) {
              return null;
            }

            return (
              <div className={styles.promoContainer}>
                {event && <EventStreamCap event={event} />}
                {newsletterSignup && (
                  <SubscribeStreamCap promo={newsletterSignup} />
                )}
              </div>
            );
          }}
        </Query>
      </ErrorBoundary>
    );
  }
}

export default StreamCap;
